module.exports = __webpack_public_path__ + "img/ken_no.0292c8b5.png";